import React from 'react';
import '../../styles/productDetail.css';

/**
 * TrustIndicators component for wholesale platforms.
 * Displays badges verifying wholesale pricing, bulk orders, supplier status, etc.
 */
const TrustIndicators = () => {
  const trustBadges = [
    'Wholesale Pricing',
    'Bulk Orders Accepted',
    'Direct Supplier',
    'Fast Dispatch',
    'Secure Packaging'
  ];

  return (
    <div className="trust-indicators-container">
      <div className="trust-indicators-grid">
        {trustBadges.map((badge, idx) => (
          <div className="trust-indicator-card" key={`trust-${idx}`}>
            <span className="trust-icon-wrapper">✓</span>
            <span className="trust-label">{badge}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustIndicators;
